<div class="table-container">
  <table mat-table [dataSource]="reportCycles" matSort>

    <ng-container matColumnDef="year">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "kf-reporting.year" | translate }} </th>
      <td mat-cell *matCellDef="let cycle"> {{cycle.year}} </td>
    </ng-container>

    <ng-container matColumnDef="unuKeySetName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "kf-reporting.UNU-key-set" | translate }} </th>
      <td mat-cell *matCellDef="let cycle"> {{cycle.unuKeySetName}} </td>
    </ng-container>

    <ng-container matColumnDef="kfCategorySetName">
      <th mat-header-cell *matHeaderCellDef
          mat-sort-header> {{ "kf-reporting.key-figure-category-set" | translate }} </th>
      <td mat-cell *matCellDef="let cycle"> {{cycle.kfCategorySetName}} </td>
    </ng-container>

    <ng-container matColumnDef="collectionStreamName">
      <th mat-header-cell *matHeaderCellDef
          mat-sort-header> {{ "kf-reporting.collection-stream-set" | translate }} </th>
      <td mat-cell *matCellDef="let cycle"> {{cycle.collectionStreamName}} </td>

    </ng-container>

    <ng-container matColumnDef="launched">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "kf-reporting.launched" | translate }} </th>
      <td mat-cell *matCellDef="let cycle"> {{cycle.launched === null ? 'Draft' : cycle?.launched | date:'short'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="open">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ "kf-reporting.charts-launched" | translate }} </th>
      <td mat-cell
          *matCellDef="let cycle"> {{cycle.reportingAvailable ? 'Yes' : cycle.launched === 'Draft' ? 'N/A' : 'No'}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let cycle" [align]="'right'">
        <a mat-icon-button *ngIf="cycle.launched && !cycle.reportingAvailable" (click)="openCharts(cycle)"
           color="primary" matTooltip="Open charts" matTooltipPosition="above">
          <mat-icon>bar_chart</mat-icon>
        </a>
        <a mat-icon-button *ngIf="cycle.launched"  (click)="print(cycle.year)" color="primary"
           matTooltip="Print" matTooltipPosition="above">
          <mat-icon>print</mat-icon>
        </a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator color="primary" [length]="totalElements"
                 [pageSize]="pageSize"
                 (page)="onPageChange($event)"
                 [pageSizeOptions]="pageSizes">
  </mat-paginator>
</div>

